import React, { useRef } from 'react'
import PrimaryTitle from '../../../../components/PrimaryTitle'
import { inject, observer } from 'mobx-react'
import { Input, DateInput, Textarea } from '../../../../components/formComponents'
import { Form, Button } from 'react-bootstrap'
import DocumentStore from '../../../../store/documentForm.store'
import PropTypes from 'prop-types'
import t from '../../../../service/translate.service'
import ContractSelector from '../../../../components/contractSelector'
import { buildValidators } from '../../../../service/validate'
import { Alert } from 'antd'
import { useNavigate } from 'react-router-dom'

const DataRelease = (props) => {
  const inputRefs = useRef({})
  const { model, setVal, dataReleaseValidators, dataReleaseValidatorInputs, errorsList, errorListVoice, submitted } = DocumentStore
  const { file } = props
  const validatorBlur = buildValidators(dataReleaseValidatorInputs, true)
  const navigate = useNavigate()

  const generateErrorList = () => {
    const errors = []
    for (let key in inputRefs?.current) {
      const item = inputRefs?.current[key]
      if (key === 'date') {
        if (validatorBlur[key] && validatorBlur[key](item?.props?.selected, item?.props['aria-label'])) {
          let err = validatorBlur[key](item?.props?.selected, item?.props['aria-label'])
          errors.push(
            <button
              key={key}
              type='button'
              onClick={() => {
                item.setFocus()
              }}
            >
              {err?.replace(/[€\*]/g, '')}
            </button>
          )
        }
      } else {
        if (validatorBlur[key] && validatorBlur[key](item.value, item.ariaLabel)) {

          let err = validatorBlur[key](item.value, item.ariaLabel)
          errors.push(
            <button
              key={key}
              type='button'
              onClick={() => {
                item.focus()
              }}
            >
              {err?.replace(/[€\*]/g, '')}
            </button>
          )
        }
      }       
    }
    return errors
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    DocumentStore.submit(file.fileName, props.contractStore.selectedContract.contractNumber, generateErrorList)
  }
  const getAttrs = field => {
    return {
      value: model[field],
      onChange: e => setVal(field, e.target.value),
      validate: dataReleaseValidators[field],
      blurValidate: validatorBlur[field]
    }
  }

  const AlertContent = () => {
    if (errorsList?.length > 0) {
      if (props?.documentFormHolderRef) {
        props.documentFormHolderRef?.current?.scrollTo(0,0)
      }
      return (
        <Alert
          role={errorListVoice ? "alert" : "none"}
          message={
            <div
              className='error-list'
              role={errorListVoice ? "alert" : "none"}
              aria-live={errorListVoice ? "assertive" : "off"}
            >
              {t.REQUIRED_FIELD_MISSING}
              {errorsList?.map((err) => {
                return err
              })}
            </div>
          }
          type='error'
          style={{ marginTop: '12px', marginBottom: '12px' }}
        />
      )
    } else {
      return (<></>)
    }
  }

  return (
    <div className="form-holder">
      <PrimaryTitle title={t.DATA_RELEASE} />
      {submitted && (
        <AlertContent />
      )}
      <Form>
        <ContractSelector required={true} label padding page='documents' aria-label={t.SELECT_CONTRACT} />
        <h3 className='inputs-text'>{t.DATA_RELEASE_HEAD_ONE}</h3>
        <Input ref={(el) => (inputRefs.current['fullName'] = el)} autoComplete="name" name='fullName' {...getAttrs('fullName')} label={t.DIGITAL_CONTRACT_FORM_FULL_NAME + '*'} aria-label={t.FULL_NAME} />
        <Input ref={(el) => (inputRefs.current['dataReleaseFileNumber'] = el)} name='dataReleaseFileNumber' {...getAttrs('dataReleaseFileNumber')} label={t.DIGITAL_CONTRACT_FORM_FILE_NUMBER + '*'} aria-label={t.FILE_NUMBER} />
        <Textarea ref={(el) => (inputRefs.current['dataReleaseResponsibleOffice'] = el)} name='dataReleaseResponsibleOffice' {...getAttrs('dataReleaseResponsibleOffice')} label={t.DIGITAL_CONTRACT_FORM_RESPONSIBLE_OFFICE + '*'} aria-label={t.RESPONSIBLE_OFFICE} />
        <Input ref={(el) => (inputRefs.current['dataReleaseContactPerson'] = el)} name='dataReleaseContactPerson' {...getAttrs('dataReleaseContactPerson')} label={t.DIGITAL_CONTRACT_FORM_CONTACT_PERSON + ' *'} aria-label={t.CONTACT_PERSON} />
        <p className='input-para'>{t.DATA_RELEASE_PARA_ONE}</p>
        <p className='input-para'>{t.DATA_RELEASE_PARA_TWO}</p>
        <Input ref={(el) => (inputRefs.current['place'] = el)} autoComplete="address-level2" name='place' {...getAttrs('place')} label={t.DIGITAL_CONTRACT_FORM_PLACE + '*'} aria-label={t.PLACE} />
        <DateInput blurValidate={validatorBlur['date']} ref={(el) => (inputRefs.current['date'] = el)} name='date' value={model['date']} onChange={(date) => setVal('date', date)} validate={dataReleaseValidators['date']} label={t.DIGITAL_CONTRACT_FORM_DATE + '*'} aria-label={t.DATE} />
        <Form.Group className='actions text-center'>
          <div className='group'>
            <button
              className='button primary'
              onClick={(e) => {
                if (e.key !== 'Tab') {
                  e.preventDefault()
                }
                onSubmit(e)
              }}
              aria-label={t.SUBMIT_BUTTON}
            >
              {t.DIGITAL_CONTRACT_FORM_SEND}
            </button>
            <a
              href='/documents'
              className='button secondary'
              onClick={(e) => {
                if (e.key !== 'Tab') {
                  e.preventDefault()
                }
                DocumentStore.onCloseForm()
                navigate('/documents')
              }}
              style={{
                textDecoration: 'none',
                color: 'unset'
              }}
              aria-label={t.CANCEL_BUTTON}
            >
              {t.DIGITAL_CONTRACT_FORM_CANCEL}
            </a>
          </div>
        </Form.Group>
      </Form>
    </div>
  );
  
}

DataRelease.propTypes = {
  file: PropTypes.object.isRequired,
  contractStore: PropTypes.object
}

export default inject('contractStore')(observer(DataRelease))
